namespace $ {
	export class $mol_svg extends $mol_view {
		
		/**
		 * ```tree
		 * dom_name \svg
		 * ```
		 */
		dom_name() {
			return "svg"
		}
		
		/**
		 * ```tree
		 * dom_name_space \http://www.w3.org/2000/svg
		 * ```
		 */
		dom_name_space() {
			return "http://www.w3.org/2000/svg"
		}
		
		/**
		 * ```tree
		 * font_size 16
		 * ```
		 */
		font_size() {
			return 16
		}
		
		/**
		 * ```tree
		 * font_family \
		 * ```
		 */
		font_family() {
			return ""
		}
		
		/**
		 * ```tree
		 * style_size *
		 * ```
		 */
		style_size() {
			return {
			} as Record< string, any >
		}
	}
	
}

